import FileSaver from 'file-saver';
import { useMutation } from 'react-query';
import { generateConsent } from '~/api/consent';

import { downloadContractUnderReview, generateContract, sendInvitation, uploadSignedContract } from '~/api/contract';

export const useGenerateConsent = () => {
  return useMutation(generateConsent);
};